/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ConcelhoCriteriaDto } from '../models/concelho-criteria-dto';
import { ConcelhoDto } from '../models/concelho-dto';
import { ConcelhoPageDto } from '../models/concelho-page-dto';
import { DistritoCriteriaDto } from '../models/distrito-criteria-dto';
import { DistritoDto } from '../models/distrito-dto';
import { DistritoPageDto } from '../models/distrito-page-dto';
import { FreguesiaCriteriaDto } from '../models/freguesia-criteria-dto';
import { FreguesiaDto } from '../models/freguesia-dto';
import { FreguesiaPageDto } from '../models/freguesia-page-dto';
import { PaisCriteriaDto } from '../models/pais-criteria-dto';
import { PaisDto } from '../models/pais-dto';
import { PaisPageDto } from '../models/pais-page-dto';


/**
 * Paises, Distritos, Concelhos e Freguesias
 */
@Injectable({
  providedIn: 'root',
})
export class LocalizacaoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getConcelhos
   */
  static readonly GetConcelhosPath = '/concelhos';

  /**
   * Pesquisar concelhos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConcelhos()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConcelhos$Response(params?: {
    criteria?: ConcelhoCriteriaDto;
  }): Observable<StrictHttpResponse<ConcelhoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, LocalizacaoService.GetConcelhosPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConcelhoPageDto>;
      })
    );
  }

  /**
   * Pesquisar concelhos.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getConcelhos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConcelhos(params?: {
    criteria?: ConcelhoCriteriaDto;
  }): Observable<ConcelhoPageDto> {

    return this.getConcelhos$Response(params).pipe(
      map((r: StrictHttpResponse<ConcelhoPageDto>) => r.body as ConcelhoPageDto)
    );
  }

  /**
   * Path part for operation getConcelho
   */
  static readonly GetConcelhoPath = '/concelhos/{id}';

  /**
   * Obter concelho.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConcelho()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConcelho$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ConcelhoDto>> {

    const rb = new RequestBuilder(this.rootUrl, LocalizacaoService.GetConcelhoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConcelhoDto>;
      })
    );
  }

  /**
   * Obter concelho.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getConcelho$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConcelho(params: {
    id: number;
  }): Observable<ConcelhoDto> {

    return this.getConcelho$Response(params).pipe(
      map((r: StrictHttpResponse<ConcelhoDto>) => r.body as ConcelhoDto)
    );
  }

  /**
   * Path part for operation getDistritos
   */
  static readonly GetDistritosPath = '/distritos';

  /**
   * Pesquisar distritos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDistritos()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDistritos$Response(params?: {
    criteria?: DistritoCriteriaDto;
  }): Observable<StrictHttpResponse<DistritoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, LocalizacaoService.GetDistritosPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DistritoPageDto>;
      })
    );
  }

  /**
   * Pesquisar distritos.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDistritos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDistritos(params?: {
    criteria?: DistritoCriteriaDto;
  }): Observable<DistritoPageDto> {

    return this.getDistritos$Response(params).pipe(
      map((r: StrictHttpResponse<DistritoPageDto>) => r.body as DistritoPageDto)
    );
  }

  /**
   * Path part for operation getDistrito
   */
  static readonly GetDistritoPath = '/distritos/{id}';

  /**
   * Pesquisar distrito.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDistrito()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDistrito$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<DistritoDto>> {

    const rb = new RequestBuilder(this.rootUrl, LocalizacaoService.GetDistritoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DistritoDto>;
      })
    );
  }

  /**
   * Pesquisar distrito.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDistrito$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDistrito(params: {
    id: number;
  }): Observable<DistritoDto> {

    return this.getDistrito$Response(params).pipe(
      map((r: StrictHttpResponse<DistritoDto>) => r.body as DistritoDto)
    );
  }

  /**
   * Path part for operation getFreguesias
   */
  static readonly GetFreguesiasPath = '/freguesias';

  /**
   * Pesquisar freguesias.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFreguesias()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFreguesias$Response(params?: {
    criteria?: FreguesiaCriteriaDto;
  }): Observable<StrictHttpResponse<FreguesiaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, LocalizacaoService.GetFreguesiasPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FreguesiaPageDto>;
      })
    );
  }

  /**
   * Pesquisar freguesias.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFreguesias$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFreguesias(params?: {
    criteria?: FreguesiaCriteriaDto;
  }): Observable<FreguesiaPageDto> {

    return this.getFreguesias$Response(params).pipe(
      map((r: StrictHttpResponse<FreguesiaPageDto>) => r.body as FreguesiaPageDto)
    );
  }

  /**
   * Path part for operation getFreguesia
   */
  static readonly GetFreguesiaPath = '/freguesias/{id}';

  /**
   * Pesquisar freguesia.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFreguesia()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFreguesia$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<FreguesiaDto>> {

    const rb = new RequestBuilder(this.rootUrl, LocalizacaoService.GetFreguesiaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FreguesiaDto>;
      })
    );
  }

  /**
   * Pesquisar freguesia.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFreguesia$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFreguesia(params: {
    id: number;
  }): Observable<FreguesiaDto> {

    return this.getFreguesia$Response(params).pipe(
      map((r: StrictHttpResponse<FreguesiaDto>) => r.body as FreguesiaDto)
    );
  }

  /**
   * Path part for operation getPaises
   */
  static readonly GetPaisesPath = '/paises';

  /**
   * Pesquisar países.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaises()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaises$Response(params?: {
    criteria?: PaisCriteriaDto;
  }): Observable<StrictHttpResponse<PaisPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, LocalizacaoService.GetPaisesPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaisPageDto>;
      })
    );
  }

  /**
   * Pesquisar países.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPaises$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaises(params?: {
    criteria?: PaisCriteriaDto;
  }): Observable<PaisPageDto> {

    return this.getPaises$Response(params).pipe(
      map((r: StrictHttpResponse<PaisPageDto>) => r.body as PaisPageDto)
    );
  }

  /**
   * Path part for operation getPais
   */
  static readonly GetPaisPath = '/paises/{id}';

  /**
   * Pesquisar país.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPais()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPais$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<PaisDto>> {

    const rb = new RequestBuilder(this.rootUrl, LocalizacaoService.GetPaisPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaisDto>;
      })
    );
  }

  /**
   * Pesquisar país.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPais$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPais(params: {
    id: number;
  }): Observable<PaisDto> {

    return this.getPais$Response(params).pipe(
      map((r: StrictHttpResponse<PaisDto>) => r.body as PaisDto)
    );
  }

}
